import 'driver.js/dist/driver.css';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Loader } from '@/components/Loader/Loader';
import { AppLayout } from '@/features/app/components/AppLayout/AppLayout';

import { AuthProvider } from './auth';
import { WebSocketProvider } from './websocket';

export function AppProvider() {
  return (
    <AuthProvider>
      <WebSocketProvider>
        <AppLayout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </WebSocketProvider>
    </AuthProvider>
  );
}
